// return date format 2023-06-22
const currentDate = () => {
  //   const today = new Date();
  //   return today.toLocaleDateString("en-GB"); // "en-GB" agar bulan dan tanggalnya slalu dua digit
  return new Date().toISOString().slice(0, 10);
};
export default currentDate;
